import { CommentRepositoryInterface } from '@/services/QC-V2/comment/interfaces';
import {
  ChatCommentInterface,
  CommentCreateInterface,
  MessageCommentInterface, ReviewCommentInterface,
} from '@/services/QC-V2/chat/interfaces';
import { AxiosInstance } from 'axios';
import { FeedbackCommentInterface } from '@/services/QC-V2/feedback/interfaces';
import { ReplyCommentInterface } from '@/services/QC-V2/ticket/interfaces';

export default class CommentRepository implements CommentRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  /// CHAT
  public async createChatComment(id: string, data: CommentCreateInterface): Promise<ChatCommentInterface> {
    const response = await this.axios.post(`/chat-controller-v2/chats/${id}/comments`, data);

    return response.data;
  }

  public async updateChatComment(chatId: string, commentId: number, data: CommentCreateInterface): Promise<void> {
    await this.axios.patch(`/chat-controller-v2/chats/${chatId}/comments/${commentId}`, data);
  }

  public async deleteChatComment(chatId: string, commentId: number): Promise<void> {
    await this.axios.delete(`/chat-controller-v2/chats/${chatId}/comments/${commentId}`);
  }

  /// MESSAGE
  public async createMessageComment(id: number, data: CommentCreateInterface): Promise<MessageCommentInterface> {
    const response = await this.axios.post(`/chat-controller-v2/messages/${id}/comments`, data);

    return response.data;
  }

  public async updateMessageComment(
    messageId: number,
    commentId: number,
    data: CommentCreateInterface,
  ): Promise<void> {
    await this.axios.patch(`/chat-controller-v2/messages/${messageId}/comments/${commentId}`, data);
  }

  public async deleteMessageComment(messageId: number, commentId: number): Promise<void> {
    await this.axios.delete(`/chat-controller-v2/messages/${messageId}/comments/${commentId}`);
  }

  // REVIEW
  public async createChatReviewComment(
    reviewId: number,
    data: CommentCreateInterface,
  ): Promise<ReviewCommentInterface> {
    const response = await this.axios.post(`/chat-controller-v2/reviews/${reviewId}/comments`, data);

    return response.data;
  }

  public async updateChatReviewComment(
    reviewId: number,
    commentId: number,
    data: CommentCreateInterface,
  ): Promise<void> {
    await this.axios.patch(`/chat-controller-v2/reviews/${reviewId}/comments/${commentId}`, data);
  }

  public async deleteChatReviewComment(reviewId: number, commentId: number): Promise<void> {
    await this.axios.delete(`/chat-controller-v2/reviews/${reviewId}/comments/${commentId}`);
  }

  public async createTicketReviewComment(
    reviewId: number,
    data: CommentCreateInterface,
  ): Promise<ReviewCommentInterface> {
    const response = await this.axios.post(`/ticket-controller-v2/reviews/${reviewId}/comments`, data);

    return response.data;
  }

  public async updateTicketReviewComment(
    reviewId: number,
    commentId: number,
    data: CommentCreateInterface,
  ): Promise<void> {
    await this.axios.patch(`/ticket-controller-v2/reviews/${reviewId}/comments/${commentId}`, data);
  }

  public async deleteTicketReviewComment(reviewId: number, commentId: number): Promise<void> {
    await this.axios.delete(`/ticket-controller-v2/reviews/${reviewId}/comments/${commentId}`);
  }

  /// FEEDBACK
  public async createChatFeedbackComment(
    feedbackId: number,
    data: CommentCreateInterface,
  ): Promise<FeedbackCommentInterface> {
    const response = await this.axios.post(`/chat-controller-v2/feedbacks/${feedbackId}/comments`, data);

    return response.data;
  }

  public async updateChatFeedbackComment(
    feedbackId: number,
    commentId: number,
    data: CommentCreateInterface,
  ): Promise<void> {
    await this.axios.patch(`/chat-controller-v2/feedbacks/${feedbackId}/comments/${commentId}`, data);
  }

  public async deleteChatFeedbackComment(feedbackId: number, commentId: number): Promise<void> {
    await this.axios.delete(`/chat-controller-v2/feedbacks/${feedbackId}/comments/${commentId}`);
  }

  public async createTicketFeedbackComment(
    feedbackId: number,
    data: CommentCreateInterface,
  ): Promise<FeedbackCommentInterface> {
    const response = await this.axios.post(`/ticket-controller-v2/feedbacks/${feedbackId}/comments`, data);

    return response.data;
  }

  public async updateTicketFeedbackComment(
    feedbackId: number,
    commentId: number,
    data: CommentCreateInterface,
  ): Promise<void> {
    await this.axios.patch(`/ticket-controller-v2/feedbacks/${feedbackId}/comments/${commentId}`, data);
  }

  public async deleteTicketFeedbackComment(feedbackId: number, commentId: number): Promise<void> {
    await this.axios.delete(`/ticket-controller-v2/feedbacks/${feedbackId}/comments/${commentId}`);
  }


  /// TICKET
  public async createTicketComment(id: number, data: CommentCreateInterface): Promise<ChatCommentInterface> {
    const response = await this.axios.post(`/ticket-controller-v2/tickets/${id}/comments`, data);

    return response.data;
  }

  public async updateTicketComment(ticketId: number, commentId: number, data: CommentCreateInterface): Promise<void> {
    await this.axios.patch(`/ticket-controller-v2/tickets/${ticketId}/comments/${commentId}`, data);
  }

  public async deleteTicketComment(ticketId: number, commentId: number): Promise<void> {
    await this.axios.delete(`/ticket-controller-v2/tickets/${ticketId}/comments/${commentId}`);
  }

  /// REPLY
  public async createReplyComment(replyId: number, data: CommentCreateInterface): Promise<ReplyCommentInterface> {
    const response = await this.axios.post(`/ticket-controller-v2/replies/${replyId}/comments`, data);

    return response.data;
  }

  public async updateReplyComment(replyId: number, commentId: number, data: CommentCreateInterface): Promise<void> {
    await this.axios.patch(`/ticket-controller-v2/replies/${replyId}/comments/${commentId}`, data);
  }

  public async deleteReplyComment(replyId: number, commentId: number): Promise<void> {
    await this.axios.delete(`/ticket-controller-v2/replies/${replyId}/comments/${commentId}`);
  }
}
